import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils';

import { type UploadLink } from './types';
import { zodUploadLinkResponseSchema } from './validations';

/**
 * Fetches an upload link for uploading a file to the Azure Blob Storage from the API.
 *
 * @param options - Additional request options.
 * @returns The upload link for uploading a file to the Azure Blob Storage.
 * @see https://app.dev.vestigas.com/redoc#tag/File/operation/get_files_upload_link_get
 */
export const fetchUploadLink = async (options?: KyRequestOptions) => {
  const response = await vestigasApi
    .get(ENDPOINT.FILE.GET_UPLOAD_LINK(), {
      ...options,
    })
    .json<UploadLink>();

  // Validate the response with Zod
  const validatedResponse = zodUploadLinkResponseSchema.safeParse(response);
  if (validatedResponse?.error?.issues?.length) {
    log.error({
      message: 'UploadLink API response has validation errors',
      error: {
        errors: validatedResponse?.error?.issues,
        errorMessage: validatedResponse?.error?.message,
        response,
      },
    });
  }

  return response;
};
